<template>
  <div>
    <Table border :columns="columns" :loading="loading" :data="dataTable" size="small" height="438">
      <template slot="action" slot-scope="{ row }">
          <Icon type="ios-paper-outline" style="color: #1DBF6D" size="20" @click="linkTo(row)"/>
      </template>
    </Table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dataTable: [],
      loading: false,
      chName:{},
      enName:{}
    };
  },
  computed: {
    lang(){
      return this.$store.getters.selectLangeData
    },
    columns(){
      return [
        {
          title: this.lang=='zh' ? this.chName.agencyApplication : this.enName.agencyApplication,
          align: "center",
          slot: "action",
          width: 150,
        },
        {
          title: this.lang=='zh' ? this.chName.applicationName : this.enName.applicationName,
          key: "applyName",
          render: (h, params) => {
              return h(
              "span",
              this.lang == 'zh' ? params.row.chName : params.row.enName
              );
          },
        },
        {
          title: this.lang=='zh' ? this.chName.applicationDescription : this.enName.applicationDescription,
          key: "applyComment",
          render: (h, params) => {
              return h(
              "span",
              this.lang == 'zh' ? params.row.commentChName : params.row.commentEnName
              );
          },
        },
      ]
    }
  },
  created() {
    this.getInternation()
    this.searchData()
  },
  methods: {
    getInternation(){
      let Obj = {
          viewType:"Common",
          beUsed : "1"
      } 
      axios.post('/International/applySelectViewSet',Obj).then((res) => {
        console.log(res)     
          this.chName= res.data[0]
          this.enName= res.data[1]
        })
    },
    searchData() {
      let arr = [
        {
          type: "B61",
          objData1:{
            beAgrent : "1"
          },
        },
      ];
      this.loading = true
      axios.post("/process/execute", arr).then((res) => {
        if(res){
          this.dataTable = [...res][0]
          console.log(this.dataTable)
        }
        this.loading = false
      });
    },
    linkTo(row) {

    },
  },
};
</script>

<style lang="scss" scoped>
.ivu-table-small {
  font-size: 12px !important;
}
.ivu-table {
  width: inherit;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  color: #515a6e !important;
  font-size: 14px;
  background-color: #fff;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/process/Apply/components/AgencyApply.vue